import { sendCaptchaVerification } from "@/src/utils/helpers";
import { Button } from "@material-tailwind/react";
import axios from "axios";
import Link from "next/link";
import { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";

export interface LoginProps {
  onSuccess: () => void;
}

const Login = ({ onSuccess }: LoginProps) => {
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [isVerified, setIsverified] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleCaptchaSubmission(token: string | null) {
    await sendCaptchaVerification(token || "")
      .then((resp) => {
        setIsverified(resp);
      })
      .catch((e) => {
        // setIsverified(false);
        setIsverified(false);
      });
  }
  const [loginFields, setLoginFields] = useState({
    username: "",
    password: "",
  });

  const onFormSubmit = (event: any) => {
    event.preventDefault();
    setErrorMessage(null);

    // Validation and Sanitization.

    setLoading(true);
    return axios({
      data: {
        username: loginFields?.username ?? "",
        password: loginFields?.password ?? "",
      },
      method: "post",
      url: "/api/login",
    })
      .then((data) => {
        const { success } = data?.data ?? {};

        // If its a preview request

        if (!success) {
          setLoading(false);
          //@ts-ignore
          setErrorMessage("Couldn't login!");
        } else {
          setTimeout(() => {
            setLoading(false);
            onSuccess();
          }, 200);
        }
      })
      .catch((e) => {
        setLoading(false);
        setErrorMessage("Couldn't Login!");
        console.log("Error: ", e);
        return false;
      });
  };

  const handleOnChange = (event: any) => {
    setLoginFields({ ...loginFields, [event.target.name]: event.target.value });
  };

  const { username, password } = loginFields;
  return (
    <>
      <div className="login-form rounded-xl md:ml-auto">
        <div
          className={
            "flex bg-scpb-dark-blue p-2 rounded-t-lg text-white items-start align-center w-full justify-center"
          }
        >
          <h4 className="text-white text-3xl title-font block">Login</h4>
        </div>
        <div className="bg-gray-100 p-8   shadow-xl">
          <form onSubmit={onFormSubmit} className="mb-4 flex flex-col">
            <div className="flex flex-col gap-2">
              <label className="leading-7 flex flex-col gap-2 text-sm text-gray-600">
                Username:
                <input
                  type="text"
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  name="username"
                  value={username}
                  onChange={handleOnChange}
                  autoComplete="username"
                />
              </label>

              <label className="leading-7 flex flex-col gap-2 text-sm text-gray-600">
                Password:
                <input
                  type="password"
                  className="w-full bg-white rounded border border-gray-300 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
                  name="password"
                  value={password}
                  onChange={handleOnChange}
                  autoComplete="current-password"
                />
              </label>
            </div>
            <div className={"py-4"}>
              {/* <ReCAPTCHA
                sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || ""}
                ref={recaptchaRef}
                onChange={handleCaptchaSubmission}
              /> */}
            </div>
            <p className="py-4 text-red-400">{errorMessage}</p>
            {errorMessage && (
              <Link href="account/recoverpassword">
                Having Trouble? Reset Password
              </Link>
            )}
            <Button
              className="text-white bg-scpb-light-blue border-0 py-2 px-8 focus:outline-none hover:bg-scpb-dark-blue rounded text-lg"
              type="submit"
              disabled={!isVerified}
            >
              {loading ? "Loading..." : "Login"}
            </Button>
          </form>
          <Link as="p" href="/register" className="cursor-pointer">
            Don&apos;t have an account?{" "}
            <span className="underline">Register</span>
          </Link>
        </div>
      </div>
    </>
  );
};

export default Login;
